
import AppBrowse from "@/components/browse/Browse.vue";
import Crm from "@/models/crm/crm";
import { BrowseService } from "@/services/browse-service";
import { ToolbarService } from "@/services/toolbar-service";
import { IBrowseDataSource } from "@/utils/browse/browse-data-source";
import Vue from "vue";
import { UserConfigService } from "../../services/user-config-service";
import { View } from "@/models/view";
import { FetchedTotal } from "@/utils/views/fetched-total";
import { CarService } from "@/services/car-service";
import Car from "@/models/base/car";
import { IQueryParams } from "@/utils/query-params";
import { checkHasModule } from "@/router";
import { MODULE } from "@/config/modules";
import { BrowseState } from "@/utils/browse/browse-state";
import AppImportCsvModal from "@/components/cars/ImportCsvModal.vue";
import { ISelectItem } from "winfakt-vue-components";
import { AuthService } from "@/services";

export default Vue.extend({
	data() {
		return {
			uploadCSVModal: false,
			selectedItems: [] as Crm[],
			browseState: null as null | BrowseState,
		};
	},
	props: {
		browseId: Number,
	},
	computed: {
		dataSource(): IBrowseDataSource<Car> {
			let elem = this;
			return {
				getFullElement: (el:Car)=>CarService.get(el.ID),
				getSettings: () => BrowseService.getBrowse(this.browseId),
				getElements: (params: IQueryParams) => CarService.getCars(params),
				getTotals(view:View):Promise<FetchedTotal[]>{
					return CarService.getTotals(view);
				},
				edit(car: Car) {
					elem.$router.push({path: `/cars/edit/${car.ID}`});
				},
				async delete(car: Car[]) {
					await CarService.delete(car);
					return true;
				},
				addRoute: `/cars/new`,
				browseName: "Car",
				modelName: "Car",
				browsePermissions: () => UserConfigService.getPermissionSettings().CarPermissions
			};
		},
		buttonBarItems():ISelectItem<string | Function>[]{
			let result = [] as ISelectItem<string | Function>[];
			result.push(
				{
					text: this.$ct("import-csv").toString(),
					value: ()=>this.uploadCSVModal = true,
					icon: "upload",
					disabled: !AuthService.hasModule(MODULE.IMPORT)
				}
			);
			return result;
		}
	},
	watch: {
		"$route.path": {
			immediate: true,
			handler(){
				if (this.$route.path == "/cars"){
					ToolbarService.title = this.$ct("cars");
				}
			}
		}
	},
	methods: {
		updateView() {
			if (!this.browseState) return;
			this.browseState.fetch();
		},
	},
	mounted() {
		ToolbarService.title = this.$ct("cars");
	},
	created(){
		if (!checkHasModule(MODULE.WAGENPARKBEHEER_PLUS_AUTOKOSTEN, this.$router)){
			throw new Error("MISSING MODULE");
		}
	},
	components: {
		AppBrowse,
		AppImportCsvModal
	},
	i18nEx: {
		componentPrefix: "components.cars"
	},
});
